import styled from "styled-components";
import { primaryColor } from "../../config/constants";

export const Body = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;
export const Header = styled.div`
  margin-bottom: ${({ marginBottom }) => marginBottom && marginBottom};
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;
export const LogoImg = styled.img`
  height: 40%;
`;
export const FormContainer = styled.form`
  margin: 0 auto;
  padding: 32px 16px;
  width: 90%;
  max-width: 370px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background-color: #fff;
`;
export const Prompt = styled.p`
  margin-bottom: 16px;
  color: #333;
  font-size: 18px;
  font-weight: 400;
`;
export const PasswordContainer = styled.div`
  margin: ${({ margin }) => margin && margin};
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
export const Label = styled.label`
  color: #1faab7;
  font-size: 18px;
  font-weight: 700;
`;
export const InputDataDiv = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
export const Input = styled.input`
  padding: 5px 32px 5px 10px;
  width: 100%;
  height: 35px;
  border: ${({ border }) => (border ? border : "1px solid #808080")};
  outline: none;
  border-radius: 4px;
  font-size: 16px;
`;
export const RelativeButton = styled.button`
  width: 23px;
  height: 23px;
  position: absolute;
  top: 6px;
  right: 8px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: 10;
`;
export const ConditionsContainer = styled.div`
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
export const ConditionText = styled.p`
  color: ${({ color }) => color && color};
  font-size: 16px;
  font-weight: 400;
`;
export const ConditionAligner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const ConditionImg = styled.img`
  width: 24px;
  opacity: ${({ opacity }) => opacity && opacity};
`;
export const SaveButton = styled.button`
  margin-top: 32px;
  padding: 7px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ background }) => background && background};
  border: none;
  border-radius: 4px;
  outline: none;
  color: ${({ color }) => color && color};
  font-size: 18px;
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;
export const OkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const WrongContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;
export const CoachImg = styled.img`
  height: 192px;
`;
export const OkContainerInfo = styled.div`
  margin: 0 auto;
  padding: 32px 16px;
  width: 90%;
  max-width: 370px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background: #fff;
  gap: 16px;
`;
export const WrongContainerInfo = styled.div`
  margin: 0 auto;
  width: 80%;
  max-width: 370px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  gap: 12px;
`;
export const Title = styled.p`
  color: #000;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
`;
export const Text = styled.p`
  color: #333;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
`;
export const DeepLink = styled.a`
  margin-top: 16px;
  padding: 12px 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${primaryColor};
  border: none;
  border-radius: 24px;
  outline: none;
  text-decoration: none;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
`;
